import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

// Kept for `/reports` links in emails, push notifications and saved tabs
export const Route = createFileRoute('/_authenticated/reports/$routineId')({
  validateSearch: z.object({
    reportId: z.coerce.number().optional(),
  }),
  beforeLoad({ params, search }) {
    throw redirect({
      to: '/routines/$routineId',
      params: { routineId: params.routineId },
      // Legacy run links name the report as reportId
      search: search.reportId
        ? { view: 'canvas', run: search.reportId }
        : undefined,
      replace: true,
    });
  },
});
